import React from "react";
import tableExport from "tableexport";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
export default class ReportListComponent extends React.Component {
  constructor(prop) {
    super(prop);
    const {t} = prop
    setTimeout(() => {
      tableExport(document.getElementsByClassName("table"), {
        headers: true,                              // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
        footers: true,                              // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
        formats: ['xlsx'],             // (String[]), filetype(s) for the export, (default: ['xls', 'csv', 'txt'])
        filename: 'id',                             // (id, String), filename for the downloaded file, (default: 'id')
        bootstrap: false,                           // (Boolean), style buttons using bootstrap, (default: true)
        exportButtons: true,                        // (Boolean), automatically generate the built-in export buttons for each of the specified formats (default: true)
        position: 'bottom',                         // (top, bottom), position of the caption element relative to table, (default: 'bottom')
        ignoreRows: null,                           // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
        ignoreCols: null,                           // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
        trimWhitespace: true                        // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: false)
      });
    }, 2000);
    this.state = {
      tooltipText: <Tooltip id="tooltip">{t('revisedCost')}</Tooltip>,
      attachmentText: <Tooltip id="tooltip">{t('costPhotoExist')}</Tooltip>
    }
  }
  render() {
    var { data, infoButton, buttonsActions, costPhoto } = this.props;
    if (!data.cost.revisions)
      data.cost.revisions = []
    if (!data.cost.costPhotos)
      data.cost.costPhotos = []
    return (
      <tr>
        <td id="reportListEmployeeName">{data.cost.revisions.length > 0 ? <OverlayTrigger placement="bottom" overlay={this.state.tooltipText}>
          <i className="fa fa-star star-color" aria-hidden="true"></i>
        </OverlayTrigger> : null}
          {data.cost.costPhotos.length > 0 ?
            <OverlayTrigger placement="bottom" overlay={this.state.attachmentText}>
              <i className="fa fa-paperclip star-color" aria-hidden="true"></i>
            </OverlayTrigger>
            :
            null
          }
          {data.employeeName}</td>
        <td id="reportListInvoiceNo">{data.cost.invoiceNo}</td>
        <td id="reportListCostType">{data.cost.costType}</td>
        <td id="reportListCostAmount">{data.cost.costAmount} {data.cost.moneyType}</td>
        <td id="reportListCostDate">{
          moment(data.cost.costDate).format('DD/MM/YYYY')
       }</td>

        <td id="reportListCostCreateDate">{data.cost.costCreatedDate}</td>
        <td>
          <button id="reportListInfoButton" type="button" onClick={() => {
            infoButton({
              employeeName: data.employeeName
            }, data.cost)
          }} className="btn btn-wd btn-info btn-fill btn-rotate actionBtn">
            <span className="btn-label"><i className="fa fa-info"></i></span></button>
          {
            data.cost.transactions
              ?
              <span>
                &nbsp;
            <button id="reportListTransactionButton" type="button" onClick={() => {
                  this.props.transactionsButton({
                    employeeName: data.employeeName
                  }, data.cost)
                }} className="btn btn-wd btn-default actionBtn"><span className="btn-label"><i className="fa fa-cogs"></i></span></button>
              </span>
              :
              null
          }
          {
          data.cost.status == "accounting" || data.cost.status == "completed"
          ?
          <span>
            &nbsp;
            <button type="button" id={"costListCostDownloadButton-"} onClick={() => { this.props.pdfDownloadButton() }} className="btn btn-primary btn-fill btn-wd actionBtn">
              <span className="btn-label"><i className="fa fa-download"></i></span>
            </button>
          </span>
          :
          null
          }
        </td>
      </tr>
    )
  }
}
